<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12" v-for="input in inputs" :key="input.key">
      <Textarea v-if="input.type === 'textarea'" v-model="projectDataLocal.article[input.key]" :placeholder="input.name" :viewMode="!canEdit" />
      <Input v-else v-model="projectDataLocal.article[input.key]" :placeholder="input.name" :viewMode="!canEdit" />
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';
import Textarea from '../../../../common/textarea';

export default {
  title: 'Acticle',
  components: {
    Input,
    Textarea,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      inputs: [
        {
          name: 'Article number',
          key: 'articleNumber',
        },
        {
          name: 'Drawing number',
          key: 'drawingNumber',
        },
        {
          name: 'Article description',
          key: 'articleDescription',
          type: 'textarea',
        },
      ],
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
